
import { HtmlHelper_createElement } from "./fable_modules/Feliz.3.3.3/Html.fs.js";
import { backgroundColor_bgSecondary700, hover, backgroundColor_bgSecondary600, textColor_textDanger600, textColor_textOnPrimary, backgroundColor_bgPrimary600, textColor_textNeutral600, backgroundColor_bgNeutral50, tw } from "./Shared/TailwindExtensions.js";
import { borderRadius_rounded, textColor_white, margin_mb2, fontSize_textSm, borderRadius_roundedLg, padding_py2, padding_px4, margin_mb4, fontWeight_fontBold, fontSize_text2Xl, textAlign_center, minHeight_minHScreen, justifyContent_justifyCenter, alignItems_itemsCenter, display_flex } from "./fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { singleton, ofArray } from "./fable_modules/fable-library-js.5.3.0/List.js";
import { parseUrl, navigate } from "./Router.js";
import { ClientTypes_Msg, ClientTypes_Route } from "./Shared/ClientTypes.js";
import { Fragment, createElement, useEffect, useState, useRef } from "react";
import React from "react";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { confirm, confirmClickAction, mountElement, createPaymentElement, changeAppearance, initCheckout, buildAppearance, loadStripe } from "./Stripe.js";
import { unwrap, orElse, some } from "./fable_modules/fable-library-js.5.3.0/Option.js";
import { Operators_IsNull } from "./fable_modules/fable-library-js.5.3.0/FSharp.Core.js";
import { createObj, disposeSafe } from "./fable_modules/fable-library-js.5.3.0/Util.js";
import { singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.5.3.0/Seq.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.3.0/Util.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.5.3.0/Result.js";
import { viewContent, view as view_1 } from "./Shared/Challenge/ChallengeEditView.js";
import { Clock_system } from "./Shared/Clock.js";
import { makePledgeApi, makeChallengeApi } from "./Index.js";
import { view as view_2 } from "./Shared/Challenge/CreateChallengeView.js";
import { view as view_3 } from "./Shared/Challenge/ChallengePublicDetailView.js";
import { view as view_4 } from "./Shared/Pledge/PledgeDetailView.js";
import { routeContent, ViewDeps } from "./Shared/RouteDispatch.js";
import { errorBoundary } from "./Sentry.js";
import { defaultOf as defaultOf_1 } from "./fable_modules/fable-library-js.5.3.0/Util.js";
import { RouterModule_router } from "./Vendor/FelizRouter.js";
import { Interop_setKeyOnObj } from "./fable_modules/Feliz.3.3.3/Helper/Helpers.fs.js";
import { toaster } from "./Toast.js";

const errorFallback = HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, minHeight_minHScreen, backgroundColor_bgNeutral50]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", textAlign_center], ["children", [HtmlHelper_createElement("h2", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, margin_mb4]))], ["children", singleton("Something went wrong")]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([textColor_textNeutral600, margin_mb4]))], ["children", singleton("An unexpected error occurred. Please return to the home page.")]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([backgroundColor_bgPrimary600, textColor_textOnPrimary, padding_px4, padding_py2, borderRadius_roundedLg]))], ["children", singleton("Return to Home")], ["onClick", (_arg) => {
    navigate(new ClientTypes_Route(0, []));
}]]))]]]))]]]));

function StripePaymentElement($props) {
    const dispatch = $props.dispatch;
    const themePref = $props.themePref;
    const email = $props.email;
    const clientSecret = $props.clientSecret;
    const checkoutRef = useRef(undefined);
    const patternInput = useState(false);
    const isReady = patternInput[0];
    const patternInput_1 = useState(false);
    const setIsConfirming = patternInput_1[1];
    const isConfirming = patternInput_1[0];
    const patternInput_2 = useState(undefined);
    const setError = patternInput_2[1];
    useEffect(() => {
        PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const stripe = loadStripe();
            const initAppearance = buildAppearance();
            return initCheckout(stripe, clientSecret, some(initAppearance)).then((_arg) => {
                const checkout = _arg;
                checkoutRef.current = checkout;
                changeAppearance(checkout, buildAppearance());
                const element = createPaymentElement(checkout);
                const node = document.getElementById("stripe-payment-element");
                if (!Operators_IsNull(node)) {
                    mountElement(element, node);
                    patternInput[1](true);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }).catch((_arg_1) => {
            setError(_arg_1.message);
            return Promise.resolve();
        }))));
    }, [clientSecret]);
    const dependencies = [themePref];
    useEffect(() => {
        const setup = (() => {
        let disp;
        const matchValue = checkoutRef.current;
        if (matchValue == null) {
        }
        else {
            changeAppearance(matchValue, buildAppearance());
        }
        if (themePref.tag === 2) {
            const handler = () => {
                const matchValue_1 = checkoutRef.current;
                if (matchValue_1 == null) {
                }
                else {
                    changeAppearance(matchValue_1, buildAppearance());
                }
            };
            const mql = matchMedia('(prefers-color-scheme: dark)');
            mql.addEventListener('change', handler);
            disp = {
                Dispose() {
                    mql.removeEventListener('change', handler);
                },
            };
        }
        else {
            disp = {
                Dispose() {
                },
            };
        }
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    return HtmlHelper_createElement("div", singleton(["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["id", "stripe-payment-element"], ["className", tw(singleton(margin_mb4))]]))), delay(() => {
        let matchValue_2, msg;
        return append((matchValue_2 = patternInput_2[0], (matchValue_2 == null) ? singleton_1(defaultOf()) : ((msg = matchValue_2, singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([textColor_textDanger600, fontSize_textSm, margin_mb2]))], ["children", singleton(msg)]])))))), delay(() => singleton_1(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([backgroundColor_bgSecondary600, textColor_white, padding_px4, padding_py2, borderRadius_rounded, hover(backgroundColor_bgSecondary700)]))], ["disabled", !isReady ? true : isConfirming], ["children", singleton(isConfirming ? "Processing..." : (isReady ? "Confirm Payment" : "Loading payment form..."))], ["onClick", (_arg_2) => {
            const matchValue_3 = confirmClickAction(checkoutRef.current);
            if (matchValue_3.tag === 1) {
                console.warn(some("Stripe: confirm clicked before checkout was initialised"));
                setError(matchValue_3.fields[0]);
            }
            else {
                setIsConfirming(true);
                console.info(some("Stripe: confirm started"));
                PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (PromiseBuilder__Delay_62FBFDE1(promise, () => (confirm(email, matchValue_3.fields[0]).then((_arg_3) => {
                    const result = _arg_3;
                    console.info(some("Stripe: confirm result " + result.Type));
                    if (result.Type === "error") {
                        setIsConfirming(false);
                        setError(orElse(result.Error, "Payment could not be completed. Please check your details."));
                        return Promise.resolve();
                    }
                    else {
                        dispatch(new ClientTypes_Msg(49, [new FSharpResult$2(0, [undefined])]));
                        return Promise.resolve();
                    }
                }))).catch((_arg_4) => {
                    setIsConfirming(false);
                    dispatch(new ClientTypes_Msg(49, [new FSharpResult$2(1, [_arg_4.message])]));
                    return Promise.resolve();
                }))));
            }
        }]])))));
    }))))]));
}

const viewDeps = new ViewDeps((model, dispatch) => view_1(Clock_system, model, dispatch, makeChallengeApi(), (clientSecret, d) => {
    let matchValue;
    return createElement(StripePaymentElement, {
        clientSecret: clientSecret,
        email: unwrap((matchValue = model.Auth, (matchValue.tag === 1) ? matchValue.fields[1] : undefined)),
        themePref: model.ThemePreference,
        dispatch: d,
    });
}), (model_1, dispatch_1) => view_2(model_1, dispatch_1, (req) => makeChallengeApi().createChallenge(req)), (model_2, dispatch_2) => viewContent(Clock_system, model_2, dispatch_2, makeChallengeApi(), (clientSecret_1, d_1) => {
    let matchValue_1;
    return createElement(StripePaymentElement, {
        clientSecret: clientSecret_1,
        email: unwrap((matchValue_1 = model_2.Auth, (matchValue_1.tag === 1) ? matchValue_1.fields[1] : undefined)),
        themePref: model_2.ThemePreference,
        dispatch: d_1,
    });
}), (model_3, dispatch_3) => view_3(Clock_system, model_3, dispatch_3), (model_4, dispatch_4) => view_4(model_4, dispatch_4, makePledgeApi()));

export function view(model, dispatch) {
    let props_1, elements;
    return errorBoundary(errorFallback, ofArray([(props_1 = createObj(ofArray([["hashMode", 2], ["onUrlChanged", (arg_1) => {
        dispatch(new ClientTypes_Msg(18, [parseUrl(arg_1)]));
    }], (elements = singleton(routeContent(viewDeps, model, dispatch)), ["application", createElement(Fragment, defaultOf_1(), ...elements)])])), (!((props_1 !== null && typeof props_1 === "object" && !Array.isArray(props_1))) ? console.error(some("React.memoRender: props must be an object.")) : undefined, createElement(RouterModule_router, Interop_setKeyOnObj(undefined, props_1)))), toaster()]));
}

//# sourceMappingURL=ClientView.js.map
